import { render, staticRenderFns } from "./AssgntDeleteModal.vue?vue&type=template&id=b810590a&scoped=true&"
import script from "./AssgntDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AssgntDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./AssgntDeleteModal.vue?vue&type=style&index=0&id=b810590a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b810590a",
  null
  
)

export default component.exports